export const LIFECYCLE_UNASSIGNED = 'Lifecycle Unassigned';
export const OTHER_STAGES = 'Other Stages';
export const STUDY_START_UP = 'Study Start-Up';
export const DOCUMENT_SOURCE_TYPE = 'document';

export const isStudyStartUp = (studyStage) => studyStage && studyStage.name === STUDY_START_UP;
export const isLifecycleUnassigned = (currentStageName) => currentStageName === LIFECYCLE_UNASSIGNED;

export const isDraftStudy = (study) => !study.binderId;
export const isUnassignedStageStudy = (study) => !study.currentStageId;

export const STUDY_DOCUMENTS_RECOMMENDATIONS = {
    'Study Start-Up': <div>
        <h3>Suggested study documents</h3>
        <p>
            Use the "Add Expectations" workflow to start tracking key study documents. We acknowledge that not all documents are needed, depending on the study type.
        </p>
        <ul>
            <li>1572</li>
            <li>Investigator Brochure</li>
            <li>Final Protocol</li>
            <li>IRB Acknowledgment Form</li>
            <li>Informed Consent Form</li>
            <li>Lab Manual</li>
            <li>Pharmacy Manual</li>
            <li>Protocol Signature </li>
            <li>Site Initiation Visit Letter</li>
        </ul>
    </div>,
    'Other Stages': <p>Use the "Add Expectations" workflow to track key study documents.</p>,
};

export const STAFF_DOCUMENTS_RECOMMENDATIONS = {
    'Study Start-Up': <div>
        <h3>Suggested staff documents</h3>
        <p>
            Use the "Add Expectations" workflow to track key staff documents and assign them to the appropriate team member roles.
        </p>
        <ul>
            <li>Current CV</li>
            <li>Current Financial Disclosure</li>
            <li>Current GCP Training</li>
            <li>Current Medical License</li>
        </ul>
    </div>,
    'Other Stages': <p>Use the "Add Expectations" workflow to track key staff documents and assign them to the appropriate team member roles.</p>,
};

